<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Ingangsdatum & Einddatum
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vul hier de ingangsdatum van het contract in en indien van toepassing ook de einddatum. De einddatum kan
                het einde ven het dienstverband zijn, maar kan ook zijn de einde een bepaald contract.
                <div class="space20"><!----></div>

                Er kunnen meerdere contract ingevuld worden.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Aard arbeidsverhouding
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het gaat hier om de aard van de arbeidsverhouding. In de meeste gevallen zal het gaan om een 'gewone'
                arbeidsovereenkomst/arbeidsverhouding. Wanneer er sprake is van een bijzondere arbeidsverhouding, kies
                dan degene die van toepassing is.
              <p>Meer informatie over aard arbeidsverhouding staat beschreven in het <a
                href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/themaoverstijgend/brochures_en_publicaties/handboek-loonheffingen"
                target="_blank"><strong>Handboek loonheffingen</strong></a>, hoofdstuk 29, onderwerp 'Code aard arbeidsverhouding'</p>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Contractduur
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">

                <b>Contract voor bepaalde tijd</b><br/>
                Een tijdelijk contract heeft een <strong>vastgestelde einddatum</strong>. Je weet van tevoren wanneer
                het contract afloopt. Dit type contract wordt vaak gebruikt voor projecten, seizoenswerk of als
                proefperiode.

                <div class="space20"><!----></div>

                <b>Kenmerken:</b>
                <ul>
                    <li>Vaste einddatum in het contract</li>
                    <li>Loopt automatisch af (geen opzegging nodig)</li>
                    <li>Maximaal 3 tijdelijke contracten achter elkaar mogelijk</li>
                    <li>Totale duur mag niet langer zijn dan 3 jaar</li>
                    <li>Minder ontslagbescherming</li>
                </ul>

                <b>Contract voor Onbepaalde Tijd</b><br/>
                Een contract voor onbepaalde tijd heeft <strong>geen einddatum</strong>. Het contract loopt door
                totdat één van de partijen het beëindigt via een opzegging of ontslag.

                <div class="space20"><!----></div>

                <b>Kenmerken:</b>
                <ul>
                    <li>Geen vastgestelde einddatum</li>
                    <li>Opzegtermijn verplicht bij beëindiging</li>
                    <li>Meer baanzekerheid voor de werknemer</li>
                    <li>Sterkere ontslagbescherming</li>
                    <li>Vaak betere arbeidsvoorwaarden</li>
                </ul>

                Voor een lage WW-premie (AWf-premie) is een schriftelijke arbeidsovereenkomst voor onbepaalde tijd
                vereist, mits het geen oproepovereenkomst is. De lage premie kan niet worden toegepast bij contracten
                voor bepaalde tijd of oproepcontracten.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Schriftelijk contract
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voor een lage WW-premie (AWf-premie) is een schriftelijke arbeidsovereenkomst voor onbepaalde tijd
                vereist, mits het geen oproepovereenkomst is. De lage premie kan niet worden toegepast bij contracten
                voor bepaalde tijd of oproepcontracten. Het contract moet schriftelijk zijn vastgelegd, gedagtekend en
                ondertekend door beide partijen. Ook moet een kopie van de overeenkomst in de administratie aanwezig
                zijn.
                <div class="space20"><!----></div>

                <b>Schriftelijk vs mondeling contract</b><br/>
                Naast het type contract is het ook belangrijk of je een <strong>schriftelijk of mondeling
                contract</strong> hebt afgesloten. Dit heeft directe gevolgen voor je salarisverwerking.
                <div class="space20"><!----></div>
                <b>Schriftelijk contract</b>
                <ul>
                    <li>Alle afspraken zijn vastgelegd op papier</li>
                    <li>Duidelijkheid over salaris, arbeidsvoorwaarden en secundaire arbeidsvoorwaarden</li>
                    <li>Makkelijker voor correcte salarisverwerking</li>
                    <li>Verplicht bij tijdelijke contracten langer dan 1 maand</li>
                </ul>

                <b>Mondeling contract</b>
                <ul>
                    <li>Alleen toegestaan bij contracten korter dan 1 maand</li>
                    <li>Onduidelijkheid over exacte afspraken</li>
                    <li>Risico op geschillen over salaris en voorwaarden</li>
                    <li>Moeilijker voor correcte loonadministratie</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Oproepcontract
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voor een lage WW-premie (AWf-premie) is een schriftelijke arbeidsovereenkomst voor onbepaalde tijd
                vereist, mits het geen oproepovereenkomst is. De lage premie kan niet worden toegepast bij contracten
                voor bepaalde tijd of oproepcontracten. Het contract moet schriftelijk zijn vastgelegd, gedagtekend en
                ondertekend door beide partijen. Ook moet een kopie van de overeenkomst in de administratie aanwezig
                zijn.

                <b>Oproepcontract</b><br/>
                Een oproepkracht heeft een <strong>contract zonder vaste uren</strong>. Je roept de werknemer alleen
                op als er werk is. Dit kan zowel tijdelijk als voor onbepaalde tijd zijn.

                <b>Kenmerken:</b>
                <ul>
                    <li>Geen vaste werkuren afgesproken</li>
                    <li>Werknemer kan oproep weigeren (tenzij anders afgesproken)</li>
                    <li>Flexibel inzetbaar bij drukte of ziekte</li>
                    <li>Betaling alleen voor gewerkte uren</li>
                    <li>Na 12 maanden recht op vast aantal uren (gemiddelde)</li>
                </ul>

                <b>Belang voor Salarisverwerking:</b>
                <ul>
                    <li><strong>Variabele uren:</strong> Elke periode andere uren invoeren</li>
                    <li><strong>Min/max uren:</strong> Let op contractuele afspraken over minimum uren</li>
                    <li><strong>Oproeprecht:</strong> Na 12 maanden automatisch recht op gemiddeld aantal uren</li>
                    <li><strong>Vakantiegeld:</strong> Berekening over alle gewerkte uren in de periode</li>
                    <li><strong>Sociale premies:</strong> Alleen over daadwerkelijk gewerkte uren</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Soort inkomstenverhouding
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>DGA (Directeur-Grootaandeelhouder)</b><br/>
                Een DGA is een <strong>directeur die ook (groot)aandeelhouder</strong> is van de BV. Dit heeft grote
                gevolgen voor de salarisverwerking omdat een DGA anders wordt behandeld dan gewone werknemers.

                <b>Wat/Wie is een DGA?</b><br/>
                <ul>
                    <li>Directeur van een BV die zelf (of met familie) meer dan 5% van de aandelen bezit</li>
                    <li>Of directeur die samen met partner meer dan 5% bezit</li>
                    <li>Heeft zeggenschap over eigen salaris en arbeidsvoorwaarden</li>
                    <li>Wordt gezien als 'ondernemer in dienst'</li>
                </ul>

                <b>Sociale verzekeringen en DGA</b>
                <ul>
                    <li><strong>WW:</strong> Niet verzekerd (eigen risico als ondernemer)</li>
                    <li><strong>WIA/WAO:</strong> Niet verplicht verzekerd (kan zich vrijwillig verzekeren)</li>
                    <li><strong>Ziekengeld:</strong> Niet verzekerd via werkgever</li>
                    <li><strong>AOW:</strong> Wel verzekerd (verplichte volksverzekering)</li>
                    <li><strong>ANW:</strong> Wel verzekerd (verplichte volksverzekering)</li>
                </ul>

                <b>Belang voor Salarisverwerking:</b>
                <ul>
                    <li><strong>Andere premieberekening:</strong> Geen WW- en WIA-premies inhouden</li>
                    <li><strong>Minimumloon DGA:</strong> Verplicht minimumloon van €49.000 (2025)</li>
                    <li><strong>Pensioenregeling:</strong> Vaak andere pensioenafspraken dan werknemers</li>
                    <li><strong>Onkostenvergoedingen:</strong> Strengere regels voor onbelaste vergoedingen</li>
                    <li><strong>Loonaangifte:</strong> Speciale DGA-velden in de polisadministratie</li>
                </ul>
                <div class="space20"><!----></div>

                Lees meer over de DGA in <a href="https://wetten.overheid.nl/BWBR0036819/2016-01-01" target="_blank">Regeling
                aanwijzing directeur-grootaandeelhouder 2016</a>.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Invloed verzekeringsplicht
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Er zijn contracten waarbij er sprake is van invloed op de verzekeringsplicht. Ook andere personen kunnen
                buiten de sociale verzekeringen vallen door hun <strong>"invloed op de
                verzekeringsplicht"</strong>:
                <ul>
                    <li><strong>Echtgenote/partner DGA:</strong> Valt ook buiten WW/WIA als zij invloed heeft op
                        bedrijfsvoering
                    </li>
                    <li><strong>Vorige eigenaar:</strong> Ex-DGA die nog steeds invloed uitoefent (bijv. als adviseur)
                    </li>
                    <li><strong>Familieleden:</strong> Kinderen, ouders die aandeelhouder zijn en invloed hebben</li>
                    <li><strong>Criterium:</strong> Kunnen zij hun eigen arbeidsvoorwaarden beïnvloeden?</li>
                </ul>

                <b>Wanneer geldt invloed verzekeringsplicht?</b>
                <ul>
                    <li>Persoon heeft (in)directe zeggenschap over eigen salaris</li>
                    <li>Kan eigen werk- en rusttijden bepalen</li>
                    <li>Heeft invloed op bedrijfsbesluiten</li>
                    <li>Formele of informele macht in het bedrijf</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Zvw verzekerd
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voor de zorgverzekering geldt een <strong>andere regeling</strong> dan voor andere sociale verzekeringen:

                <h4>Gewone werknemers - Werkgeversheffing ZVW:</h4>
                <ul>
                    <li><strong>Werkgever betaalt:</strong> ZVW-heffing van vastgesteld % over het loon</li>
                    <li><strong>Werknemer betaalt:</strong> Eigen risico en nominale premie aan zorgverzekeraar</li>
                    <li><strong>Geen netto inhouding:</strong> Werknemer ziet dit niet terug op loonstrook</li>
                    <li><strong>Werkgever draagt kosten:</strong> ZVW-heffing is werkgeverskosten</li>
                </ul>

                <h4>DGA's - Netto inhouding bijdrage ZVW:</h4>
                <ul>
                    <li><strong>Geen werkgeversheffing:</strong> Werkgever betaalt geen % ZVW-heffing</li>
                    <li><strong>Netto inhouding:</strong> DGA betaalt zelf een bijdrage via loonstrook</li>
                    <li><strong>Zichtbaar op loonstrook:</strong> Inhouding van circa €5.000-€6.000 per jaar</li>
                    <li><strong>DGA draagt kosten:</strong> Eigen kosten, niet van de werkgever</li>
                    <li><strong>Plus eigen premie:</strong> DGA betaalt ook nog zorgpremie aan verzekeraar</li>
                </ul>
            </div>
        </div>
    </div>
</div>

